import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import NavbarBottom from './NavbarBottom';
import { Link } from 'react-router-dom';

import Modal from 'react-modal';

const PDFModal = ({ pdfUrl, onClose }) => {
    return (
        <div className="modal">
            <div className="modal-content">
                <iframe src={pdfUrl} title="PDF Viewer" width="100%" height="500px" />
                <button onClick={onClose}>Close</button>
            </div>
        </div>
    );
};



function DetailProdukHukumTerkait() {
    const params = useParams();
    const [newsDetail, SetNewsDetail] = useState([]);

     const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => {
        setIsModalOpen(true);
    };
    const closeModal = () => {
        setIsModalOpen(false);
    };

    const StatusDoc = (id) => {
        if (id == 1) {
            return <div>Berlaku</div>;
        } else if (id == "2") {
            return <div>Mencabut</div>;
        }
        else if (id == "3") {
            return <div>Dicabut</div>;
        }
        else if (id == "4") {
            return <div>Mengubah</div>;
        }
        else if (id == "5") {
            return <div>Diubah</div>;
        }
        else {
            return <div></div>;
        }
    }

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_ENDPOINT}/documents-detail/${params.id}`)
            .then((res) => {
                return res.json();
            })
            .then((datas) => {
                console.log(datas.data[0]);
                SetNewsDetail(datas.data[0]);
        });

        

        //console.log(newsDetail);
    }, []);

    const getLang = localStorage.getItem('lang_code');

    return (
        <>
            <NavbarBottom />
            <div className="p-4">
                <div class="max-w-7xl mx-auto bg-white shadow-md rounded-lg overflow-hidden">
                    <div class="bg-blue-900 text-white p-6">
                        <h2 class="text-sm font-light">{newsDetail.nama}</h2>
                        <h1 class="text-lg font-semibold mt-1">
                            {newsDetail.content}
                        </h1>
                    </div>

                    <div class="p-6">
                        <div class="bg-blue-100 p-4 rounded-lg flex justify-between items-center">
                            <h3 class="font-semibold text-blue-900">📄 MATERI POKOK PERATURAN</h3>
                            <button class="bg-blue-900 text-white px-4 py-2 rounded-lg text-sm">
                                {newsDetail.file_abstrak !='' ?
                                    <a href={`${process.env.REACT_APP_BASEURL}/produk_hukum/abstrak/${newsDetail.file_abstrak}`}>Abstrak</a>
                                    :
                                    '-'
                                }
                               
                            </button>
                        </div>
                        {/*<p class="text-gray-700 mt-4">
                        Bank Indonesia dibebaskan dari kewajiban termasuk dalam pasal 16 ayat1 Undang-undang Pokok Bank Indonesia
                        1953 untuk masa duabelas bulan lagi dari tanggal 1 Nopember 1957 sampai tanggal 1 Nopember1958, yaitu
                        dari berakhirnya Undang-undang Darurat No.14 tahun 1957Jo. Undang-undang No.63 tahun 1958.
                    </p>*/}

                        <div class="bg-gray-100 p-4 rounded-lg mt-6">
                            <h3 class="font-semibold text-gray-700 flex items-center"><i class="fas fa-info-circle mr-2"></i> METADATA
                                PERATURAN</h3>
                            <div class="mt-4">
                                <div class="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                                    <div class="bg-white p-2 rounded-lg">
                                        <strong>Jenis</strong>
                                        <p>{newsDetail.nama}</p>
                                    </div>
                                    <div class="bg-white p-2 rounded-lg">
                                        <strong>Pemrakarsa</strong>
                                        <p>{newsDetail.pemrakarsa}</p>
                                    </div>
                                    <div class="bg-white p-2 rounded-lg">
                                        <strong>Entitas</strong>
                                        <p>
                                            {newsDetail.singkatan_jenis == 'PERDA' ? 'Pemerintah Daerah' : 'Pemerintah Kota'}
                                        </p>
                                    </div>
                                    <div class="bg-white p-2 rounded-lg">
                                        <strong>Penandatangan</strong>
                                        <p>{newsDetail.penandatangan}</p>
                                    </div>
                                    <div class="bg-white p-2 rounded-lg">
                                        <strong>Singkatan Jenis</strong>
                                        <p>{newsDetail.singkatan_jenis}</p>
                                    </div>
                                    <div class="bg-white p-2 rounded-lg">
                                        <strong>Hasil Uji Materi</strong>
                                        <p>{newsDetail.hasil_uji_materi}</p>
                                    </div>
                                    <div class="bg-white p-2 rounded-lg">
                                        <strong>Nomor</strong>
                                        <p>{newsDetail.no_peraturan}</p>
                                    </div>
                                    <div class="bg-white p-2 rounded-lg">
                                        <strong>T.E.U</strong>
                                        <p>{newsDetail.tajuk_entri_utama}</p>
                                    </div>
                                    <div class="bg-white p-2 rounded-lg">
                                        <strong>Tahun</strong>
                                        <p>{newsDetail.tahun_diundang}</p>
                                    </div>
                                    <div class="bg-white p-2 rounded-lg">
                                        <strong>Lokasi</strong>
                                        <p>{newsDetail.lokasi}</p>
                                    </div>
                                    <div class="bg-white p-2 rounded-lg">
                                        <strong>Judul</strong>
                                        <p>{newsDetail.content}</p>
                                    </div>
                                    <div class="bg-white p-2 rounded-lg">
                                        <strong>Pengarang</strong>
                                        <p>{newsDetail.pengarang}</p>
                                    </div>
                                    <div class="bg-white p-2 rounded-lg">
                                        <strong>Ditetapkan Tanggal</strong>
                                        <p>{newsDetail.tgl_ditetap}</p>
                                    </div>
                                    <div class="bg-white p-2 rounded-lg">
                                        <strong>Tempat Penerbit</strong>
                                        <p>{newsDetail.tmp_terbit}</p>
                                    </div>
                                    <div class="bg-white p-2 rounded-lg">
                                        <strong>Diundangkan Tanggal</strong>
                                        <p>{newsDetail.tgl_diundang}</p>
                                    </div>
                                    {/*<div class="bg-white p-2 rounded-lg">
                                        <strong>Status</strong>
                                        <p>{newsDetail.status == 1 ? 'Berlaku' : 'Tidak Berlaku'}</p>
                                    </div>*/}
                                    <div class="bg-white p-2 rounded-lg">
                                        <strong>Bidang Hukum</strong>
                                        <p>{newsDetail.bidhukumnama}</p>
                                    </div>
                                    {/*<div class="bg-white p-2 rounded-lg">
                                        <strong>Keterangan Status</strong>
                                        <p>{newsDetail.status == 1 ? 'Berlaku' : 'Tidak Berlaku'}</p>
                                    </div>*/}
                                    <div class="bg-white p-2 rounded-lg">
                                        <strong>Sumber</strong>
                                        <p>{newsDetail.sumber}</p>
                                    </div>
                                    <div class="bg-white p-2 rounded-lg">
                                        <strong>Bahasa</strong>
                                        <p>{newsDetail.language}</p>
                                    </div>
                                    <div class="bg-white p-2 rounded-lg">
                                        <strong>Diakses</strong>
                                        <p>{newsDetail.view}</p>
                                    </div>
                                    <div class="bg-white p-2 rounded-lg">
                                        <strong>Diunduh</strong>
                                        <p>{newsDetail.unduh}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="bg-white p-4 rounded-lg shadow-md mt-6">
                            <div class="grid grid-cols-2 gap-4">
                                <div>
                                    <h3 class="font-semibold text-gray-700"><i class="fas fa-file-alt mr-2"></i> FILE-FILE PERATURAN</h3>
                                    <p class="mt-2 text-gray-700">{newsDetail.file_tags}</p>
                                    <div class="mt-3 flex space-x-2">
                                        {/*<button class="bg-gray-300 px-4 py-2 rounded-lg text-sm">🔍 Preview</button>*/}
                                        <button class="bg-blue-900 text-white px-4 py-2 rounded-lg text-sm">
                                            <a href={`${process.env.REACT_APP_BASEURL}/${newsDetail.file_url}`} class="flex items-center text-red-500 font-medium text-sm mt-2">
                                                ⬇️
                                                Download
                                            </a>
                                        </button>
                                        <button onClick={openModal} class="bg-orange-900 text-white px-4 py-2 rounded-lg text-sm">
                                            ⬇️
                                            Preview
                                        </button>
                                    </div>
                                </div>
                                <div>
                                    <h3 class="font-semibold text-gray-700"><i class="fas fa-file-alt mr-2"></i> STATUS PERATURAN</h3>
                                    <div class="mt-3 flex space-x-2">
                                        <span class="bg-gray-300 px-4 py-2 rounded-lg text-sm">
                                            {StatusDoc(newsDetail.status_prod)}
                                        </span>
                                        
                                    </div>
                                    <p class="mt-2 text-gray-700">
                                        <Link to={`/detail-produk-hukum/${newsDetail.prod_terkait}`}>
                                            <em>{newsDetail.judul_terkait}</em>
                                        </Link>
                                    </p>
                                </div>
                            </div>
                        </div><br />

                         <div>
                            <Modal
                                isOpen={isModalOpen}
                                onRequestClose={closeModal}
                                contentLabel="PDF Modal"
                                style={{
                                    overlay: {
                                        backgroundColor: 'rgba(0, 0, 0, 0.5)'
                                    },
                                    content: {
                                        width: '100%',
                                        height: '80%',
                                        maxWidth: '80%',
                                        maxHeight: '80%',
                                        margin: 'auto'
                                    }
                                }}
                            >
                                <object data={`https://docs.google.com/viewerng/viewer?url=${process.env.REACT_APP_BASEURL}/${newsDetail.file_url}&embedded=true`} style={{ width: '100%', height: '90%' }}></object>
                                <div class="px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                    <button type="button" onClick={closeModal} class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs ring-1 ring-gray-300 ring-inset hover:bg-gray-50 sm:mt-0 sm:w-auto">Close</button>
                                </div>
                            </Modal>
                        </div>
                        

                        {/*<div class="bg-white p-4 rounded-lg shadow-md mt-6">
                        <h3 class="font-semibold text-gray-700"><i class="fas fa-info-circle mr-2"></i> STATUS PERATURAN</h3>
                        <p class="text-red-600 font-semibold mt-2">Belum Tersedia</p>
                    </div>*/}

                        {/*<div class="mt-6 text-gray-600 text-sm">
                            Halaman ini telah diakses <span class="text-red-600">{newsDetail.unduh}</span> kali
                        </div>

                        <div class="flex space-x-3 mt-4">
                            <a href="#" class="text-blue-600 text-lg"><i class="fab fa-twitter"></i></a>
                            <a href="#" class="text-green-600 text-lg"><i class="fab fa-whatsapp"></i></a>
                            <a href="#" class="text-blue-700 text-lg"><i class="fab fa-facebook"></i></a>
                            <a href="#" class="text-gray-600 text-lg"><i class="fas fa-share-alt"></i></a>
                        </div>

                        <div class="bg-white p-4 rounded-lg shadow-md mt-6">
                            <h3 class="font-semibold text-gray-700"><i class="fas fa-balance-scale mr-2"></i> UJI MATERI</h3>
                            <p class="text-red-600 font-semibold mt-2">Belum Tersedia</p>
                        </div>*/}
                    </div>
                </div>
            </div>
        </>
    );
}

export default DetailProdukHukumTerkait;
